export default {
  en: {
    'LABEL': 'Breakdown:',
    'UPDATE_LEVEL_TT': 'Click to change breakdown level',
    'DELETE_LEVEL_TT': 'Delete this breakdown level',
    'ADD_LEVEL_TT': 'Click to add breakdown level',
    'LEVEL': 'LEVEL'
  }
};